export default Object.freeze({
  RPContract: 5,
});
